import { render, staticRenderFns } from "./ChronicleHit.vue?vue&type=template&id=47c81a53"
import script from "./ChronicleHit.vue?vue&type=script&lang=js"
export * from "./ChronicleHit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports